import MenuItem from "@material-ui/core/MenuItem";
import DPSelect from "Components/DP/DPSelect/DPSelect";
import React from "react";
import pretty from "Shared/pretty";
import { useEmployers } from "Hooks/useEmployers";
import { useProviderDisbursements } from "../useProviderDisbursements";

export function RequestorFilter() {
  const { employers } = useEmployers({
    permissions: ["canCreateDisbursements"]
  });
  const { onChangeRequestor, requesterId } = useProviderDisbursements();

  const options = [
    { label: "All", value: "" },
    ...employers.map(employer => {
      return {
        label: pretty.fullName(employer.firstName || "", employer.lastName || ""),
        value: employer.id,
      };
    }),
  ];

  return (
    <DPSelect
      inputLabel="Requestor Name"
      selectedIndex={
        requesterId
          ? options.findIndex(option => option.value === requesterId)
          : undefined
      }
      onIndexChanged={(index) => {
        onChangeRequestor(options[index].value);
      }}
    >
      {options.map((option, index) => (
        <MenuItem key={option.value} value={index}>
          <span>{option.label}</span>
        </MenuItem>
      ))}
    </DPSelect>
  );
}
